/**
 * Genesys specific Course Availability enums
 */
export enum CourseAvailability {
  FREE = 'Free',
}
